module.exports = __webpack_public_path__ + "img/sv43on.d1383f99.svg";